import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { faRulerHorizontal } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';
import { ActiveTool } from 'src/components/viewers/SheetsViewerV2/enums/ActiveTool';
import { useSheetViewerV2 } from 'src/components/viewers/SheetsViewerV2/hooks/useSheetViewerV2';

export default function MeasureToolButton(): React.ReactElement {
  const { measurement, calibration, setActiveTool } = useSheetViewerV2();
  const { t } = useTranslation('project');

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <Tooltip
      label={
        calibration.existing
          ? t('viewer-interactions.measure-toggle')
          : t('viewer-interactions.calibration-required')
      }
    >
      <IconButton
        aria-label="Measure tool"
        icon={
          <SparkelIcon
            icon={faRulerHorizontal}
            color={measurement.isMeasuring ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={measurement.isMeasuring}
        colorScheme={measurement.isMeasuring ? 'teal' : 'gray'}
        variant={measurement.isMeasuring ? 'toggle' : 'solid-no-transparent'}
        isDisabled={!calibration.existing}
        size="xs"
        onClick={() => {
          if (measurement.isMeasuring) {
            setActiveTool(ActiveTool.Default);
          } else {
            setActiveTool(ActiveTool.Measurement);
          }
        }}
      />
    </Tooltip>
  );
}
